module.exports = __webpack_public_path__ + "static/media/seri108.3d1ac4a8.jpg";